<template>
  <div>
    <customize-page
      label-position="left"
      ref="page"
      inline
      :loading="loading"
      :data="dataList"
      :columns="columns"
      :pagination="pagination"
      :formConfig="getFormConfig()"
      :filterObj="filterObj"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    >
      <div slot="footer">
        <el-button style="margin-right: 10px" type="primary" @click="search">
          搜索
        </el-button>
        <el-button style="margin-right: 10px" @click="reset">重置</el-button>
        <el-button
          style="margin-right: 10px"
          type="primary"
          v-hp="'add'"
          @click="showAddOrModifyView(null)"
        >
          新增
        </el-button>
      </div>
    </customize-page>

    <el-dialog
      :title="(formData.id === '' ? '新增' : '修改') + '商户'"
      width="450px"
      :visible.sync="showFormDialog"
    >
      <el-form
        style="width: 400px; margin: 0 auto"
        ref="form"
        :model="formData"
        label-width="80px"
      >
        <el-form-item label="商户名">
          <el-input v-model="formData.merchantName"></el-input>
        </el-form-item>
        <el-form-item label="描述">
          <el-input v-model="formData.description"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="save()">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog
      title="绑定企业"
      :visible.sync="showBindEnterpriseFlag"
      width="360px"
    >
      <el-form>
        <el-form-item label="企业">
          <el-select
            filterable
            style="width: 260px"
            v-model="formData.enterpriseNids"
            multiple
            placeholder="请选择企业"
          >
            <el-option-group
              v-for="group in getEnterprise"
              :key="group.label"
              :label="group.label"
            >
              <el-option
                v-for="item in group.options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-option-group>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button v-on:click="saveBind" style="float: right" type="primary"
            >保存</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import CustomizePage from "@/components/customize-page";
import Page from "@/mixin/Page";

import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    CustomizePage,
  },
  mixins: [Page],
  created() {
    this.defaultFormData = JSON.stringify(this.formData);
  },
  mounted() {
    this.fetch();
  },
  data() {
    return {
      loading: false,
      dataList: [],
      showFormDialog: false,
      defaultFormData: "",
      showBindEnterpriseFlag: false,
      currentMerchant: null,
      formData: {
        id: "",
        merchantName: "",
        description: "",
        enterpriseNids: [],
      },
      columns: [
        {
          type: "selection",
          width: 50,
          align: "center",
          fixed: "left",
        },
        {
          title: "商户名",
          width: 200,
          fixed: "left",
          key: "merchantName",
          align: "center",
        },
        {
          title: "描述",
          width: 200,
          fixed: "left",
          key: "description",
          align: "center",
        },
        {
          title: "企业",
          minWidth: 200,
          fixed: "left",
          key: "enterpriseNames",
          align: "center",
          render: (h, param) => {
            let result = [];
            let enterpriseNames = param.row.enterpriseNames;
            if (enterpriseNames != null && enterpriseNames.trim().length > 0) {
              enterpriseNames
                .trim()
                .split(",")
                .forEach((name) => {
                  result.push(<el-tag size="mini">{name}</el-tag>);
                });
            }
            return result;
          },
        },
        {
          title: "创建时间",
          width: 180,
          key: "gmtCreate",
          align: "center",
        },
        {
          title: "修改时间",
          width: 180,
          key: "gmtModified",
          align: "center",
        },
        {
          title: "操作",
          width: 180,
          align: "center",
          render: (h, param) => {
            let data = param.row;
            let operation = [];
            if (this.$hasPermission(this.$route, "edit")) {
              operation.push(
                <el-button
                  type="text"
                  style="color:blue"
                  onClick={this.showAddOrModifyView.bind(this, data)}
                >
                  编缉
                </el-button>
              );
            }

            if (this.$hasPermission(this.$route, "bindEnterprise")) {
              operation.push(
                <el-button
                  type="text"
                  style="color:blue"
                  onClick={this.showBindDialog.bind(this, data)}
                >
                  绑定企业
                </el-button>
              );
            }
            return operation;
          },
        },
      ],
      filterObj: {
        channelName: "",
      },
      currentRow: [],
      sortObj: {},
    };
  },
  computed: {
    ...mapGetters({
      getEECommerce: "getEECommerce",
      getEnterprise: "getEnterprise",
    }),
  },
  methods: {
    ...mapActions("merchantStore", {
      list: "listMerchant",
      addOrModify: "addOrModifyMerchant",
      bindEnterprise: "merchantBindEnterprise",
    }),
    showBindDialog(data) {
      this.currentMerchant = data;
      this.formData.enterpriseNids = [];
      if (
        data.enterpriseNids != null &&
        data.enterpriseNids.trim().length > 0
      ) {
        this.formData.enterpriseNids = data.enterpriseNids.split(",");
      }
      this.showBindEnterpriseFlag = !this.showBindEnterpriseFlag;
    },
    saveBind() {
      let bindEnterpriseNidList = [];
      this.formData.enterpriseNids.forEach((item) => {
        bindEnterpriseNidList.push({
          enterpriseNid: item,
        });
      });
      this.bindEnterprise({
        request: JSON.stringify({
          merchantId: this.currentMerchant.id,
          data: bindEnterpriseNidList,
        }),
      }).then((res) => {
        if (res.value) {
          this.showBindEnterpriseFlag = !this.showBindEnterpriseFlag;
          this.fetch();
          this.$message.success("保存成功");
        } else {
          this.$message.error("保存失败");
        }
      });
    },
    fetch() {
      this.loading = true;
      const filterParams = this.getFilterParams();
      const sortObj = this.sortObj;
      let searchCondition = {
        ...sortObj,
        request: JSON.stringify({
          ...filterParams,
          pageInfo: {
            pageIndex: this.pagination.currentPage,
            pageSize: this.pagination.pageSize,
          },
        }),
      };

      this.list(searchCondition)
        .then((res) => {
          this.loading = false;
          this.dataList = res.items || [];
          const pageInfo = res.pageInfo || { totalCount: 0 };
          this.pagination.totalCount = pageInfo.totalCount;
        })
        .catch((error) => {
          this.loading = false;
          this.$message.error("异常");
        });
    },
    showAddOrModifyView(data) {
      if (data != null) {
        this.formData.id = data.id;
        this.formData.merchantName = data.merchantName;
        this.formData.description = data.description;
      } else {
        this.formData = JSON.parse(this.defaultFormData);
      }
      this.showFormDialog = !this.showFormDialog;
    },
    save() {
      this.addOrModify({
        request: JSON.stringify({ data: this.formData }),
      }).then((res) => {
        if (res.value) {
          this.showFormDialog = !this.showFormDialog;
          this.fetch();
          this.$message.success("保存成功");
        } else {
          this.$message.error("保存失败");
        }
      });
    },
    getFormConfig() {
      const type = this.getFormItemType();
      return [
        {
          data: [
            {
              label: "商户名",
              model: "merchantName",
              type: type.INPUT,
            },
          ],
        },
      ];
    },
  },
};
</script>
